import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { TenantsService } from 'src/services/tenants.service';

const AUTHORIZED_REDIRECT_URI_PAGE =
  'https://console.cloud.google.com/apis/credentials/oauthclient/507797187790-shg9lue7j204ejkag4uetb0c76rqa6c7.apps.googleusercontent.com?project=trnout-co';

@Component({
  selector: 'app-create-tenant-modal',
  templateUrl: './create-tenant-modal.component.html',
  styleUrls: ['./create-tenant-modal.component.scss'],
})
export class CreateTenantModalComponent {
  public isLoading = false;
  public subdomain = '';
  public name = '';
  public passwordAuthEnabled = true;
  public googleAuthEnabled = true;
  public allowedEmailDomains = '';
  public trialEnabled = true;
  public hasUpdatedAuthorizedRedirectUris = true; // we now do this automatically on the backend
  public isInternalSupport = false;

  constructor(
    private tenantsService: TenantsService,
    private modalCtrl: ModalController,
  ) {}

  dismiss() {
    this.modalCtrl.dismiss();
  }

  async updateAuthorizedRedirects() {
    this.hasUpdatedAuthorizedRedirectUris = true;

    await navigator.clipboard.writeText(`https://${this.subdomain}.unthread.io/__/auth/handler`);

    window.open(AUTHORIZED_REDIRECT_URI_PAGE, '_blank');
  }

  async submit() {
    if (!this.hasUpdatedAuthorizedRedirectUris) {
      alert('Please update the authorized redirect URIs before submitting.');
      return;
    }

    this.isLoading = true;

    await this.tenantsService.createTenant({
      subdomain: this.subdomain,
      name: this.name,
      passwordAuthEnabled: this.passwordAuthEnabled,
      googleAuthEnabled: this.googleAuthEnabled,
      accountStatus: this.trialEnabled ? 'trial' : 'active',
      isInternalSupport: this.isInternalSupport,
      allowedEmailDomains: this.allowedEmailDomains
        .split(',')
        .filter((v) => v)
        .map((d) => d.trim().toLowerCase()),
    });

    window.open(`https://${this.subdomain}.unthread.io/dashboard/people`, '_blank');

    this.dismiss();
  }
}
